import {styled} from '@mui/material';
import TableCell from '@mui/material/TableCell';

export default styled(TableCell)({
  padding: '0.5rem 2.5rem',
  borderWidth: 0,
});
